import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class LogicPost extends DesigntimeComponent {
  static staticName = "Logic: Post to backend";
  static staticId = "logicPost";
  hasRuntimeView = false;

  bmiName = "bmi";
  brand = "brand";
  backendUrl = "http://url-to-backend.se";
  language = "";
  riskLevel = "-1";
  accountIndex = 0;
  version = 1;
  visitId = "0";
  selectedPostDefinition = {};
  selectedValues = {};

  constructor(identifyer) {
    super(identifyer, 1);
  }

  getDesignerView(outputs, nodes) {
    this.clearRemoved(outputs, nodes);

    var $designerView = DesigntimeComponent.prototype.getDesignerView.call(this, outputs);

    for (var outputIndex in outputs) {
      var output = outputs[outputIndex];

      if (output.id == this.id)
        continue;

      if (output.key.includes("url:"))
        continue;

      var uniqueId = this.id + "_input_" + output;

      var $formcheck = $("<div class='form-check' data-key='" + output.key + "'></div>")

      var $checkbox = $("<input id='" + uniqueId + "'class='form-check-input' type='checkbox'>");
      $checkbox.change(this.storePostDefinition.bind(this));
      $formcheck.append($checkbox);

      var $label = $("<label class='form-check-label' for='" + uniqueId + "'>" + output.key + "</label>");
      $formcheck.append($label);

      var $textbox = $("<input class='form-control si-post-text' type='text' placeholder='" + output.key + "'>");
      $textbox.change(this.storePostDefinition.bind(this));
      $formcheck.append($textbox);

      if (this.selectedPostDefinition[output.key] && this.selectedPostDefinition[output.key].checked) {
        $checkbox.prop("checked", true);
        $textbox.val(this.selectedPostDefinition[output.key].text);
      }

      $designerView.append($formcheck);
    }

    for (var index in nodes) {
      var nodeId = nodes[index];

      if (nodeId == "node_top") continue;

      var uniqueId = this.id + "_input_" + nodeId;

      var $formcheck = $("<div class='form-check' data-key='" + nodeId + "'></div>")

      var $checkbox = $("<input id='" + uniqueId + "'class='form-check-input' type='checkbox'>");
      $checkbox.change(this.storePostDefinition.bind(this));
      $formcheck.append($checkbox);

      var $label = $("<label class='form-check-label' for='" + uniqueId + "'>" + nodeId + "</label>");
      $formcheck.append($label);

      var $textbox = $("<input class='form-control si-post-text' type='text' placeholder='" + nodeId + "'>");
      $textbox.change(this.storePostDefinition.bind(this));
      $formcheck.append($textbox);

      if (this.selectedPostDefinition[nodeId] && this.selectedPostDefinition[nodeId].checked) {
        $checkbox.prop("checked", true);
        $textbox.val(this.selectedPostDefinition[nodeId].text);
      }

      $designerView.append($formcheck);
    }

    this.eventBroker.subscribeOnce("loggNodeEvent", this.onLoggNode.bind(this), this.id);
    this.eventBroker.subscribeOnce("loggOutputEvent", this.onLoggOutput.bind(this), this.id);

    return $designerView;
  }

  onLoggNode(nodeId) {
    if (this.selectedPostDefinition[nodeId]) {
      this.selectedPostDefinition[nodeId].checked = true;
      siSuccess(`Added ${nodeId} to shown-logging`)
      return;
    }
    this.selectedPostDefinition[nodeId] = { checked: true, text: "[" + nodeId + " shown]" };
    siSuccess(`Added ${nodeId} to shown-logging`)
  }

  onLoggOutput(outputDef) {
    if (this.selectedPostDefinition[outputDef.id]) {
      this.selectedPostDefinition[outputDef.id].checked = true;
      siSuccess(`Added ${outputDef.id} to output-logging`)
      return;
    }
    this.selectedPostDefinition[outputDef.id] = { checked: true, text: "[" + outputDef.type + " output]" };
    siSuccess(`Added ${outputDef.id} to output-logging`)
  }

  clearRemoved(outputs, nodes) {
    var deleted = [];

    for (var index in this.selectedPostDefinition) {
      var found = false;

      for (var i in outputs) {
        if (outputs[i].key == index)
          found = true;
      }

      for (var i in nodes) {
        if (nodes[i] == index)
          found = true;
      }

      if (!found)
        deleted.push(index);
    }

    for (var i in deleted) {
      delete this.selectedPostDefinition[deleted[i]];
    }
  }

  storePostDefinition(e) {
    let $formcheck1 = $(e.currentTarget).parent(".form-check")
    var clickedKey = $formcheck1.data("key");
    var checked = $formcheck1.children(".form-check-input").prop("checked");
    var text = $formcheck1.children(".si-post-text").val();

    var postDefinition = {
      checked: checked,
      text: text
    }

    if (checked) {
      this.selectedPostDefinition[clickedKey] = postDefinition;
    } else {
      delete this.selectedPostDefinition[clickedKey];
    }
  }

  getRuntimeView(context) {
    for (var valueIndex in this.selectedValues) {
      this.selectedValues[valueIndex] = 0;
    }

    this.eventBroker.subscribe("valueChangedEvent", this.onChanged.bind(this));
    this.eventBroker.subscribe("nodeShownEvent", this.onShown.bind(this));

    return $(`<div class='${this.type}'></div>`);
  }

  onShown(nodeId) {
    if (this.selectedPostDefinition[nodeId]) {
      var text = this.selectedPostDefinition[nodeId].text;
      if (text == "")
        text = nodeId;
      this.postData(this.backendUrl, this.getLoggPost("shown", text));
    }
  }

  getLoggPost(jsonkey, jsonvalue) {
    var loggPost = {};
    loggPost.key = this.bmiName;
    loggPost.brand = this.brand;
    loggPost.language = this.language;
    loggPost.version = this.version;
    loggPost.accountIndex = this.accountIndex;
    loggPost.riskLevel = this.riskLevel;
    loggPost.visitId = this.visitId;

    var payload = {};
    payload[jsonkey] = jsonvalue;
    loggPost.payload = JSON.stringify(payload);
    return loggPost;
  }

  onChanged(params) {
    if (params.id == this.id)
      return;
    if (params.key == "url:bmiName")
      this.bmiName = params.value;
    if (params.key == "url:brand")
      this.brand = params.value;
    if (params.key == "url:languageCultureName")
      this.language = params.value;
    if (params.key == "url:accountIndex")
      this.accountIndex = params.value;
    if (params.key == "url:riskLevel")
      this.riskLevel = params.value;
    if (params.key == "bmi:version")
      this.version = params.value;
    if (params.key == "bmi:backendUrl")
      this.backendUrl = params.value;
    if (params.key == "url:visitId")
      this.visitId = params.value;

    if (!this.selectedPostDefinition[params.key])
      return;

    var text = params.key;
    if (this.selectedPostDefinition[params.key].text != "")
      text = this.selectedPostDefinition[params.key].text;

    this.postData(this.backendUrl, this.getLoggPost(text, params.value));
  }

  postData(url, loggPost) {
    $.ajax({
      url: url,
      dataType: 'json',
      method: "POST",
      contentType: 'application/json',
      data: JSON.stringify(loggPost)
    }).fail(function (a, b) {
      console.Error("Failed to post data to " + url, a, b);
    });
  }

  importModel(model) {
    super.importModel(model);
    this.selectedPostDefinition = model.selectedPostDefinition || {};
  };

  exportModel() {
    var res = super.exportModel()
    res.selectedPostDefinition = this.selectedPostDefinition;
    return res;
  }

  output = [];
}

export { LogicPost }
